import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  ArticleFacetedSearchQuery,
  ArticleFacetedSearchService,
  ArticleFacetedSearchStore,
  FilterQuery,
  FilterService,
  FilterStore,
  ProductPageViewFilterService,
} from '@lobos/library';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import { ComponentsModule } from '../../../../components/components.module';
import { PipesModule } from '../../../../pipes/pipes.module';
import { CatalogComponentsModule } from '../../catalog-components/catalog-components.module';
import { ProductPageComponent } from './product-page/product-page.component';
import { ProductComponentsModule } from './product-components/product-components.module';

const routes: Routes = [
  {
    path: '',
    component: ProductPageComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ComponentsModule,
    CatalogComponentsModule,
    TranslocoModule,
    ProductComponentsModule,
  ],
  declarations: [ProductPageComponent],
  providers: [
    ArticleFacetedSearchQuery,
    ArticleFacetedSearchService,
    ArticleFacetedSearchStore,
    ProductPageViewFilterService,
    FilterQuery,
    FilterStore,
    FilterService,
    PipesModule,
    { provide: TRANSLOCO_SCOPE, useValue: 'catalog' },
  ],
  exports: [],
})
export class ProductModule {}
